export const SET_AUTH_AGENT_FORM_VALUES = "SET_AUTH_AGENT_FORM_VALUES";

export const SUBMIT_AUTH_AGENT_BEGIN = "SUBMIT_AUTH_AGENT_BEGIN";
export const SUBMIT_AUTH_AGENT_SUCCESS = "SUBMIT_AUTH_AGENT_SUCCESS";
export const SUBMIT_AUTH_AGENT_FAILURE = "SUBMIT_AUTH_AGENT_FAILURE";
